import { useQuery } from 'react-query'

import getTtsToken from '../services/getTtsToken'
import requestTextToSpeech from '../services/requestTextToSpeech'

// Second param is an optional object of configuration options
export default function useTextToSpeech(title, { enabled = true } = {}) {
  // TTS token will only be fetched once, not once per call to this hook,
  // since the query string will remain stable between calls.
  const { data: ttsToken } = useQuery('ttsToken', getTtsToken)

  return useQuery(
    ['flashcardTts', title],
    () =>
      requestTextToSpeech({
        text: title,
        token: ttsToken,
        url: process.env.ESL_TTS_URL,
      }),
    {
      // query requires the TTS token to be resolved before firing;
      // optionally pass an `enabled` flag in the hook's options params
      // to prevent firing a request before it's needed (see Flashcard.js)
      enabled: !!ttsToken && enabled,
    }
  )
}
